import { Box, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'

import { LIGHT_CARD_BORDER, SUMMARY_I18N_PREFIX } from './showShared'

const CARD_DIVIDER_COLOR = 'rgba(148, 163, 184, 0.16)'

const IncidentReportShowCard = ({ titleSuffix, icon: Icon, children, height = { xs: 'auto', lg: 580 } }) => {
  const translate = useTranslate()

  return (
    <Box
      sx={{
        height,
        borderRadius: 2,
        backgroundColor: 'background.paper',
        boxShadow: LIGHT_CARD_BORDER,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        '& > *:not(:last-child)': {
          borderBottom: '1px solid',
          borderColor: CARD_DIVIDER_COLOR,
        },
        gap: 2,
      }}
    >
      <Box
        sx={{
          px: { xs: 2, md: 2.25 },
          py: 1.35,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Icon sx={{ fontSize: 18, color: 'primary.main' }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {translate(`${SUMMARY_I18N_PREFIX}.${titleSuffix}`)}
        </Typography>
      </Box>
      {children}
    </Box>
  )
}

export default IncidentReportShowCard
